import { render, staticRenderFns } from "./WorldHierarchy.vue?vue&type=template&id=e2672416&scoped=true&"
import script from "./WorldHierarchy.vue?vue&type=script&lang=ts&"
export * from "./WorldHierarchy.vue?vue&type=script&lang=ts&"
import style0 from "./WorldHierarchy.vue?vue&type=style&index=0&id=e2672416&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2672416",
  null
  
)

export default component.exports